import React from 'react';
import './ResortMap.css';
import { HandDrawnButton } from '../shared/HandDrawnButton/HandDrawnButton';

type fromTuple = {
    heading?: string;
    description?: string;
};

interface ResortMapProps {
    foregroundColor: string;
    backgroundColor: string;
    backgroundImage?: string;
    backgroundVideo?: string;
    mapImageUrl: string;
    heading: string;
    fromList?: fromTuple[];
    contactUs?: {
        label: string;
        link: string;
    },
    learnMore?: {
        label: string;
        link: string;
    }
}

function ResortMap({ foregroundColor, backgroundColor, backgroundImage, backgroundVideo, mapImageUrl, heading, fromList, contactUs, learnMore }: ResortMapProps) {
    const componentStyle = {
        '--_color' : foregroundColor,
        '--_background-color': backgroundColor,
    } as React.CSSProperties;

    return (
        <div className="resort-map" style={{ backgroundImage: `url(${backgroundImage})` }}>
            {
                backgroundImage &&
                <div className="resort-map__image-background" style={{ backgroundImage: `url(${backgroundImage})` }}></div>
            }
            {
                backgroundVideo &&
                <video className="resort-map__video-background" src={backgroundVideo} autoPlay muted loop />
            }
            <div className="resort-map__inner" style={componentStyle}>
                <div className="resort-map__media">
                    <img src={mapImageUrl} alt="map" className="resort-map__map-image" />
                </div>
                <div className="resort-map__content">
                    <h2 className="resort-map__heading">
                        {heading}
                    </h2>
                    <div className="resort-map__text">
                        {fromList &&
                            <div className="resort-map__from-list">
                                {
                                    fromList.map(from_item =>
                                        <div className="resort-map__from-item">
                                            {from_item.heading && <div className="resort-map__from-item-heading is-info-heading" dangerouslySetInnerHTML={{__html: from_item.heading}}/>}
                                            {from_item.description && <div className="resort-map__from-item-content is-info-content" dangerouslySetInnerHTML={{__html: from_item.description}}/>}
                                        </div>
                                    )
                                }

                            </div>
                        }

                        {
                            (contactUs || learnMore) &&
                            <div className="resort-map__action-list">
                                {
                                    contactUs &&
                                    <div className="resort-map__action-item">
                                        <HandDrawnButton
                                            text={contactUs.label}
                                            variant="atacama"
                                            color="off-white"
                                            size="normal"
                                            animation="stroke-to-fill"
                                        />
                                    </div>
                                }
                                {
                                    learnMore &&
                                    <div className="resort-map__action-item">
                                        <HandDrawnButton
                                            text={learnMore.label}
                                            variant="atacama"
                                            color="off-white"
                                            size="normal"
                                            animation="stroke-to-fill"
                                        />
                                    </div>
                                }
                            </div>
                        }

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResortMap;